import React from "react";
import { Box, Grid, Typography } from "@mui/material";

import CurrencyRupeeIcon from "@mui/icons-material/CurrencyRupee";
import { convertDateToCustomFormat } from "../../utils/commonUtils";
import dayjs from "dayjs";
export default function SmbAccountReachargeCard({ item }) {
  return (
    <Grid item xs={12} sx={{ padding: "0 0px 10px 0 !important" }}>
      <Grid
        container
        sx={{
          py: "10px",
          px: {xs:"10px", sm:"10px"},
          backgroundColor: "#E3E3FF",
          fontFamily: "'Montserrat', sans-serif",
          borderRadius: "5px",
        }}
      >
        <Grid item xs={3}>
          <Typography
            // fontSize={"15px"}
            sx={{
              display: "flex",
              justifyContent: "left",
              alignItems: "center",
              paddingLeft: { lg: "70px", md: "40px" },
              color: (theme) => theme.palette.primary.main,
              fontWeight: "600",
              fontSize: { xs: "10px", sm: "12px", md: "15px" },
            }}
          >
            {item?.smbPackage}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            // fontSize={"15px"}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "500",
              fontSize: { xs: "10px", sm: "12px", md: "15px" },
            }}
          >
            {dayjs(item?.invoiceDate).format("DD/MM/YYYY")}
          </Typography>
        </Grid>
        <Grid item xs={3}>
          <Typography
            // fontSize={"15px"}
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              fontWeight: "500",
              fontSize: { xs: "10px", sm: "12px", md: "15px" },
            }}
          >
            {item?.reference}
          </Typography>
        </Grid>
        <Grid
          item
          xs={3}
          sx={{
            display: "flex",
            justifyContent: "right",
            alignItems: "center",
            paddingRight: { xs: "0px", sm: "10px", lg: "70px", md: "30px" },
          }}
        >
          <CurrencyRupeeIcon fontSize="10px" />
          <Typography
            component="span"
            // fontSize={"15px"}
            sx={{
              fontWeight: "500",
              fontSize: { xs: "10px", sm: "12px", md: "15px" },
            }}
          >
            {item?.amount.toFixed(1)}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
}
